import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  quantity: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

function QuantitySelector({ quantity, onChange }) {
  return (
    <div className="AddToCart__QuantitySelector">
      <button
        className="AddToCart__ChangeQuantity"
        onClick={() => onChange(-1)}
        disabled={quantity < 2}
      >
        -
      </button>

      <div className="AddToCart__CurrentQuantity">{quantity}</div>

      <button className="AddToCart__ChangeQuantity" onClick={() => onChange(1)}>
        +
      </button>
    </div>
  );
}

QuantitySelector.propTypes = propTypes;

export default QuantitySelector;



// WEBPACK FOOTER //
// ./src/components/shared/QuantitySelector/QuantitySelector.jsx